// src/redux/aboutSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { base_url } from '../../pages/Constants';
// Define the async thunk for fetching data
export const fetchAboutData = createAsyncThunk(
  'aboutPage/fetchData',
  async () => {
    const lang  =  localStorage.getItem('current_lang') || 'en'; 
    const response = await axios.get(`${base_url}/api/about-page`,{
      headers:{
        language:lang
      }
    });
    return response.data; 
  }
);

// Create a slice 
const aboutSlice = createSlice({
  name: 'aboutPage',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAboutData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAboutData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchAboutData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

// Export the reducer
export default aboutSlice.reducer;
